module.exports = __webpack_public_path__ + "static/media/pie_chart.a546b0e2.svg";